var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_79",
    "data-name": "Group 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69096",
    "data-name": "Path 69096",
    d: "M58.071,0a8.5,8.5,0,0,0-1.522.155,7.981,7.981,0,0,0-6.106,9.96,4.367,4.367,0,0,1-1.121,4.276L47.7,16.016A4.239,4.239,0,0,1,43.67,17.2a7.568,7.568,0,0,0-3.9.013,4.234,4.234,0,0,1-4.038-1.188l-1.472-1.472a4.375,4.375,0,0,1-1.107-4.326,8.154,8.154,0,0,0,.033-4.4,8,8,0,0,0-15.6,3.511,8.049,8.049,0,0,0,5.784,6.364,7.881,7.881,0,0,0,3.415.171,4.329,4.329,0,0,1,3.784,1.23l2.173,2.172a4.357,4.357,0,0,1,1.183,4.029,7.659,7.659,0,0,0,.29,4.3A7.984,7.984,0,0,0,49.74,24.951a7.542,7.542,0,0,0-.2-1.738,4.283,4.283,0,0,1,1.193-3.99l2.148-2.148a4.339,4.339,0,0,1,3.862-1.217,7.768,7.768,0,0,0,4.093-.342A7.988,7.988,0,0,0,58.225,0Z",
    transform: "translate(-17.482)",
    fill: "#61cafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69097",
    "data-name": "Path 69097",
    d: "M40.2,52.641a8.025,8.025,0,0,0-5.981,5.194,7.661,7.661,0,0,0-.29,4.3,4.357,4.357,0,0,1-1.183,4.028l-2.173,2.172a4.329,4.329,0,0,1-3.784,1.23,7.881,7.881,0,0,0-3.415.171,8,8,0,0,0,3.807,15.531,7.932,7.932,0,0,0,6-5.657,8.158,8.158,0,0,0-.033-4.4,4.372,4.372,0,0,1,1.107-4.325l1.472-1.473a4.232,4.232,0,0,1,4.038-1.188,7.568,7.568,0,0,0,3.9.013A4.242,4.242,0,0,1,47.7,69.427l1.624,1.625a4.371,4.371,0,0,1,1.121,4.278,8,8,0,1,0,10.389-5.4,7.788,7.788,0,0,0-4.093-.343,4.336,4.336,0,0,1-3.862-1.216L50.728,66.22a4.279,4.279,0,0,1-1.193-3.989,7.55,7.55,0,0,0,.2-1.739,8,8,0,0,0-8-7.995,8.383,8.383,0,0,0-1.543.143",
    transform: "translate(-17.482 -52.498)",
    fill: "#61cafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69098",
    "data-name": "Path 69098",
    d: "M.156,27.077a7.979,7.979,0,0,0,9.958,6.106A4.373,4.373,0,0,1,14.392,34.3l1.625,1.624A4.242,4.242,0,0,1,17.2,39.956a7.593,7.593,0,0,0,.013,3.9,4.232,4.232,0,0,1-1.188,4.038l-1.473,1.473a4.373,4.373,0,0,1-4.325,1.106,8.158,8.158,0,0,0-4.4-.033,8,8,0,0,0,3.511,15.6,8.049,8.049,0,0,0,6.364-5.784,7.881,7.881,0,0,0,.171-3.415,4.329,4.329,0,0,1,1.23-3.784l2.172-2.173A4.357,4.357,0,0,1,23.308,49.7a7.661,7.661,0,0,0,4.3-.29,7.984,7.984,0,0,0-2.658-15.519,7.507,7.507,0,0,0-1.739.205A4.282,4.282,0,0,1,19.224,32.9l-2.148-2.148a4.336,4.336,0,0,1-1.216-3.862,7.787,7.787,0,0,0-.343-4.093,8.034,8.034,0,0,0-6.227-5.21A8.4,8.4,0,0,0,8,17.482a8,8,0,0,0-7.84,9.595",
    transform: "translate(0 -17.482)",
    fill: "#61cafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69099",
    "data-name": "Path 69099",
    d: "M76.156,17.583a8.034,8.034,0,0,0-6.227,5.21,7.768,7.768,0,0,0-.342,4.093,4.339,4.339,0,0,1-1.217,3.862L66.221,32.9a4.286,4.286,0,0,1-3.99,1.194,7.494,7.494,0,0,0-1.738-.205,7.984,7.984,0,0,0-2.658,15.519,7.659,7.659,0,0,0,4.3.29,4.357,4.357,0,0,1,4.029,1.183l2.172,2.173a4.327,4.327,0,0,1,1.23,3.784,7.868,7.868,0,0,0,.172,3.415,8,8,0,0,0,15.53-3.807,7.932,7.932,0,0,0-5.657-6,8.154,8.154,0,0,0-4.4.033,4.377,4.377,0,0,1-4.326-1.106l-1.472-1.473a4.233,4.233,0,0,1-1.188-4.038,7.58,7.58,0,0,0,.012-3.9,4.239,4.239,0,0,1,1.188-4.028L71.053,34.3a4.37,4.37,0,0,1,4.276-1.121,7.98,7.98,0,0,0,9.96-6.106,8.442,8.442,0,0,0,.155-1.524V25.4a8,8,0,0,0-8-7.921,8.391,8.391,0,0,0-1.292.1",
    transform: "translate(-52.498 -17.482)",
    fill: "#61cafa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(15.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 50.14,
    height: 34.739,
    transform: "translate(-0.802 -0.985)",
    fill: "#61cafa"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(15.669 47.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 50.228,
    height: 33.932,
    transform: "translate(-0.802 -0.001)",
    fill: "#61cafa"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0 15.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 34.74,
    height: 49.464,
    transform: "translate(-0.985 0)",
    fill: "#61cafa"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(47.054 15.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 34.739,
    height: 49.464,
    transform: "translate(-0.807 0)",
    fill: "#61cafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPassport);
export default __webpack_public_path__ + "static/media/ai_passport.84db7a337a19af11b3ddfec35e7584bb.svg";
export { ForwardRef as ReactComponent };